import { render } from "./moderation_tools.vue?vue&type=template&id=b04ea1aa"
import script from "./moderation_tools.js?vue&type=script&lang=js"
export * from "./moderation_tools.js?vue&type=script&lang=js"

import "./moderation_tools.vue?vue&type=style&index=0&id=b04ea1aa&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__